<template>
    <v-flex xs12 class="filter-options">
        <v-layout row wrap class="filter-options__filters"
                  mt-3
                  v-if="!isLocation && !hasOnlyOneTypeAheadAsOption">
            <v-flex xs12 sm6 md4 lg3 pa-1 pr-2 v-for="(ribbonItem, index) in filterItem.filters"
                    v-if="showRibbonCheckboxOption(ribbonItem)"
                    :key="getRandomId(index)"
                    class="filter-options__individual"
            >
                <label v-if="!ribbonItem.isTypeAhead && (ribbonItem.subFilters && ribbonItem.subFilters.length === 0)"
                       class="check-container ypo_blue_color">
                    <v-layout :class="isPreviouslySelected(ribbonState[filterItem.key], ribbonItem) ? 'bold-font' : ''"  class="desktop-view-wrap">
                        <v-flex class="check-container--label"
                                :data-qe-id="`member-directory_${filterItem.key}-desktop_option-${index}_label`">
                            {{ribbonItem.label}}
                        </v-flex>
                        <v-flex class="check-container--count" :data-qe-id="`member-directory_${filterItem.key}-desktop_option-${index}_count`"
                                    v-if="labelWithCount(ribbonItem)">
                                {{labelWithCount(ribbonItem)}}
                        </v-flex>
                    </v-layout>
                    <v-layout :class="isPreviouslySelected(ribbonState[filterItem.key], ribbonItem) ? 'bold-font' : ''"  class="mobile-view-wrap">
                        <v-flex class="check-container--label"
                                :data-qe-id="`member-directory_${filterItem.key}-mobile_option-${index}_label`">
                            {{ribbonItem.label}}
                        <span class="check-container--count" :data-qe-id="`member-directory_${filterItem.key}-mobile_option-${index}_count`"
                                v-if="labelWithCount(ribbonItem)">
                            {{labelWithCount(ribbonItem)}}
                        </span>
                        </v-flex>
                    </v-layout>
                    <input type="checkbox"
                           :value="ribbonItem"
                           :data-qe-id="`member-directory_${filterItem.key}-_option-${index}_checkbox`"
                           v-model="ribbonState[filterItem.key]">
                    <span class="checkmark"></span>
                </label>

                <filter-with-secondary-options
                        :is-previously-selected="isPreviouslySelected"
                        :filter-item="ribbonItem"
                        :filter-index="index"
                        :parent-filter-key="filterItem.key"
                        v-if="!ribbonItem.isTypeAhead && ribbonItem.subFilters && ribbonItem.subFilters.length > 0">
                </filter-with-secondary-options>

                <filter-type-ahead :filter-item="ribbonItem"
                                   :filter-index="index"
                                   :parent-filter-key="filterItem.key"
                                   :reset-search-text="resetSearchText"
                                   v-if="ribbonItem.isTypeAhead">
                </filter-type-ahead>
            </v-flex>
        </v-layout>

        <v-layout row wrap v-if="displayTypeAhead"
                  class="filter-options__typeAhead">
            <v-flex xs12 class="no-left-pa filter-options__sub-label">
                {{selectedTypeAhead.label}}
            </v-flex>
            <v-flex xs12 sm8 md6 lg6 pt-2>
                <v-text-field
                        class="filter-options__typeAhead-input"
                        outline
                        hide-details
                        @keyup="getTypeAheadResult"
                        :data-qe-id="`member-directory_${selectedTypeAhead.key}_typeahead_input`"
                        :placeholder="selectedTypeAhead.placeHolder"
                        v-model="typeAheadSearchText">
                </v-text-field>
                <v-layout column
                          class="filter-options__typeAhead-result inner-scrollbar"
                          v-if="typeAheadSearchText && typeAheadSearchText.length > 2">
                    <status-overlay
                            :action="typeAheadAction"
                            content-height="60px"></status-overlay>
                    <v-flex xs4
                            class="filter-options__typeAhead-result--item"
                            v-if="selectedTypeAhead.searchResult && selectedTypeAhead.searchResult.length > 0"
                            v-for="(searchItem, index) in selectedTypeAhead.searchResult"
                            :key="getRandomId(index)" pa-2>
                        <label class="check-container ypo_blue_color">
                            <span>{{searchItem.label}}</span>
                            <input type="checkbox"
                                   :value="searchItem"
                                   :data-qe-id="`member-directory_${selectedTypeAhead.key}_result-${index}_checkbox`"
                                   v-model="ribbonState[filterItem.key]">
                            <span class="checkmark"></span>
                        </label>
                    </v-flex>
                    <v-flex xs4 pa-2
                            v-if="selectedTypeAhead.searchResult && selectedTypeAhead.searchResult.length === 0"
                            :data-qe-id="`member-directory_${selectedTypeAhead.key}_typeahead_no-result`"
                            class="bold-font ypo_blue_color">
                        {{memberDirectoryPageConstant.label.NO_TYPE_AHEAD_RESULT_FOUND}}
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md6 pa-2 mt-3
                    class="filter-options__typeAhead-previous"
                    v-if="selectedTypeAhead.previouslySelected && selectedTypeAhead.previouslySelected.length > 0">
                <v-layout row wrap>
                    <v-flex xs3
                            v-for="(selectedItem, index) in selectedTypeAhead.previouslySelected"
                            :key="getRandomId(index)" pa-2>
                        <label class="check-container ypo_blue_color">
                            <span>{{selectedItem.label}}</span>
                            <input type="checkbox"
                                   :value="selectedItem"
                                   :data-qe-id="`member-directory_${selectedTypeAhead.key}_typeahead-previously-selected_checkbox-${index}`"
                                   v-model="ribbonState[filterItem.key]">
                            <span class="checkmark"></span>
                        </label>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex>
                <v-layout column v-if="privateNetworks && privateNetworks.length" pt-2>
                    <v-flex v-for="(privateNetwork, index) in privateNetworks"
                            class="private_networks"
                            :key="index" pa-2 >
                        <span class="ypo_cta_blue_color">{{privateNetwork.label}}</span>
                        <span class="ypo_red_color">{{privateMessage(privateNetwork)}}</span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout column
                  v-if="!isLocation && selectedSubFilter && selectedSubFilter.subFilters && selectedSubFilter.subFilters.length > 0"
                  class="filter-options__subFilters" pt-3>
            <v-flex xs12 class="filter-options__sub-label">
                {{selectedSubFilter.label}}
            </v-flex>
            <v-flex xs12 sm6 md4 lg3 pt-3 >
                <v-layout  class="filter-options__subFilters-options " row wrap >
                    <v-flex pa-2 xs12 md4 sm6 v-for="(subFilter, index) in selectedSubFilter.subFilters"
                            class="relative-position"
                            v-if="subFilter.label"
                            :key="getRandomId(index)">
                        <div class="blocked-filter pointer" v-if="hasChildrenSelected(subFilter)"
                             :data-qe-id="`member-directory_${filterItem.key}_sub-filter_option-${index}_link`"
                             @click="handleThirdLayerOfFilter(subFilter)"></div>
                        <label class="check-container ypo_blue_color">
                            <v-layout row wrap :class="isPreviouslySelected(ribbonState[filterItem.key], subFilter) ? 'bold-font' : ''" class="desktop-view-wrap">
                                <v-flex class="check-container--label flex-grow-overwrite"
                                        :data-qe-id="`member-directory_${filterItem.key}_desktop-sub-filter_option-${index}_label`">
                                    {{subFilter.label}}
                                </v-flex>
                                <v-flex class="check-container--count"
                                        :data-qe-id="`member-directory_${filterItem.key}_desktop-sub-filter_option-${index}_count`"
                                        v-if="labelWithCount(subFilter)">
                                    {{labelWithCount(subFilter)}}
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isPreviouslySelected(ribbonState[filterItem.key], subFilter) ? 'bold-font' : ''" class="mobile-view-wrap">
                                <v-flex class="check-container--label flex-grow-overwrite"
                                        :data-qe-id="`member-directory_${filterItem.key}_mobile-sub-filter_option-${index}_label`">
                                    {{subFilter.label}}
                                <span class="check-container--count"
                                      :data-qe-id="`member-directory_${filterItem.key}_mobile-sub-filter_option-${index}_count`"
                                        v-if="labelWithCount(subFilter)">
                                    {{labelWithCount(subFilter)}}
                                </span>
                                </v-flex>
                            </v-layout>
                            <input type="checkbox"
                                   :value="subFilter"
                                   @change="handleThirdLayerOfFilter(subFilter)"
                                   :data-qe-id="`member-directory_${filterItem.key}_sub-filter_option-${index}_checkox`"
                                   v-model="ribbonState[filterItem.key]">
                            <span :class="['checkmark', isPreviouslySelected(ribbonState[filterItem.key], subFilter) ? 'checked-box' : '']"></span>
                        </label>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout column
                  v-if="!isLocation && selectedSubFilter && thirdListOfOptions && thirdLayerFilters.subFilters && thirdLayerFilters.subFilters.length"
                  class="filter-options__subFilters" pt-3>
            <v-flex xs12 class="filter-options__sub-label">
                {{labelForThirdLayerFilter(thirdLayerFilters)}}
            </v-flex>
            <v-flex wrap xs12 sm6 md4 lg3 pt-3>
                <v-layout class="filter-options__subFilters-options" row wrap>
                    <v-flex pa-2 xs12 sm6 md4 v-for="(subFilterItem, index) in thirdLayerFilters.subFilters"
                            v-if="subFilterItem.label"
                            :key="getRandomId(index)"
                            class="filter-options__subFilters-options__individual"
                    >
                        <label class="check-container ypo_blue_color">
                            <v-layout :class="isPreviouslySelected(ribbonState[filterItem.key], subFilterItem) ? 'bold-font' : ''" class="desktop-view-wrap">
                                <v-flex class="check-container--label">
                                    {{subFilterItem.label}}
                                </v-flex>
                                <v-flex class="check-container--count"
                                        v-if="labelWithCount(subFilterItem)">
                                    {{labelWithCount(subFilterItem)}}
                                </v-flex>
                            </v-layout>
                            <v-layout :class="isPreviouslySelected(ribbonState[filterItem.key], subFilterItem) ? 'bold-font' : ''" class="mobile-view-wrap">
                                <v-flex class="check-container--label">
                                    {{subFilterItem.label}}
                                <span class="check-container--count"
                                        v-if="labelWithCount(subFilterItem)">
                                    {{labelWithCount(subFilterItem)}}
                                </span>
                                </v-flex>
                            </v-layout>
                            <input type="checkbox"
                                   :value="subFilterItem"
                                   :data-qe-id="`member-directory_${filterItem.key}_third-filter-option-${index}_checkbox`"
                                   v-model="ribbonState[filterItem.key]">
                            <span class="checkmark"></span>
                        </label>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <member-location v-if="isLocation" :filter-item="filterItem"></member-location>
    </v-flex>
</template>

<script>
    import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { memberDirectoryPageConstant, thirdLayerFilerOptions, privateCommunityMessage } from "../memberDirectoryPage.constants";
    import { getRandomId, numberCommaSeparated } from "../../../common/utils/utils";
    import FilterTypeAhead from "./FilterTypeAhead";
    import FilterWithSecondaryOptions from "./FilterWithSecondaryOptions";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import StatusOverlay from "../../StatusOverlay/StatusOverlay";
    import { routerNames } from "../../appCommon.constants";
    import MemberLocation from "./MemberLocation";

    export default {
        name: 'FilterOptions',
        components: {
            StatusOverlay,
            FilterWithSecondaryOptions,
            FilterTypeAhead,
            MemberLocation,
        },
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
            selectedRibbonFilter: {
                type: Object,
                required: true,
            },
        },
        data() {
          return {
              typeAheadSearchText: '',
              timeoutForTypeAhead: null,
              memberDirectoryPageConstant,
              thirdLayerFilters: null,
              isLocation: this.filterItem.key === memberDirectoryPageConstant.constant.memberLocationKey,
          };
        },
        methods: {
            getRandomId,
            ...mapActions({
                initiateTypeAheadSearch: `memberDirectory/${storeAction.initiateTypeAheadSearch}`,
            }),
            ...mapMutations({
                resetTypeAheadResult: `memberDirectory/${storeMutation.resetTypeAheadResult}`,
                removeNestedCheckBoxFilters: `memberDirectory/${storeMutation.removeNestedCheckBoxFilters}`,
            }),
            privateMessage(privateCommunity) {
                return privateCommunityMessage(privateCommunity);
            },
            resetSearchText() {
                this.typeAheadSearchText = '';
            },
            getTypeAheadResult() {
                if (this.selectedTypeAhead
                    && this.typeAheadSearchText
                    && this.typeAheadSearchText.length < 3) {
                    this.resetTypeAheadResult();
                }

                if (this.selectedTypeAhead && this.typeAheadSearchText && this.typeAheadSearchText.length > 2) {
                    const additionalFilters = this.$route.name === routerNames.MEMBER_CONNECTIONS
                    && this.$route.query.additionalFilters
                        ? JSON.parse(this.$route.query.additionalFilters)
                        : null;
                    const typeAheadObject = {
                        searchText: this.typeAheadSearchText,
                        additionalFilters,
                        typeAheadAdditionalFilter: null,
                    };
                    this.initiateTypeAheadSearch(typeAheadObject)
                        .catch(() => {});
                }
            },
            showRibbonCheckboxOption(item) {
                return item.count > 0 || item.isTypeAhead || (item.subFilters && item.subFilters.length > 0);
            },
            numberCommaSeparated,
            labelWithCount(ribbonItem) {
                const { count } = ribbonItem;
                let countToShow = null;

                if (count > 0 && !ribbonItem.ignoreNonZeroCount) {
                    countToShow = `(${numberCommaSeparated(count)})`;
                    if (this.selectedFilters && this.filterItem) {
                        const itemInSf = this.selectedFilters[this.filterItem.key].length;
                        if (itemInSf) {
                            countToShow = null;
                        }
                    }
                }
                return countToShow;
            },
            handleThirdLayerOfFilter(filter) {
                  if (this.selectedSubFilter && filter && filter.subFilters && this.filterItem) {
                      if (this.ribbonState &&
                          this.ribbonState[this.filterItem.key]
                              .includes(this.ribbonState[this.filterItem.key]
                                  .find(it => it.filterKey === filter.filterKey && it.filterValue === filter.filterValue))) {
                          this.thirdLayerFilters = filter;
                      } else {
                          this.thirdLayerFilters = null;
                      }
                  }
            },
            hasChildrenSelected(filter) {
                let hasChildInState = false;
                if (this.selectedSubFilter && this.filterItem
                    && filter && filter.subFilters && filter.subFilters.length) {
                    hasChildInState =
                        filter.subFilters.some(item => this.ribbonState[this.filterItem.key]
                            .includes(this.ribbonState[this.filterItem.key]
                                .find(it => it.filterKey === item.filterKey && it.filterValue === item.filterValue)));
                }
                return hasChildInState;
            },
            labelForThirdLayerFilter(filter) {
                const itemFound = thirdLayerFilerOptions.find(item => item.key === filter.filterKey);
                return itemFound
                    ? itemFound.label
                    : `${memberDirectoryPageConstant.label.DEFAULT_SUB_FILTER_LABEL} (OPTIONAL)`;
            },
            isPreviouslySelected(selectedList, filterItem) {
                let result = false;
                if (selectedList && selectedList.length && filterItem) {
                    result = selectedList.some(item => item.filterKey === filterItem.filterKey && item.filterValue === filterItem.filterValue);
                }
                return result;
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                ribbonState: `memberDirectory/${storeGetters.ribbonState}`,
                selectedTypeAhead: `memberDirectory/${storeGetters.selectedTypeAhead}`,
                selectedSubFilter: `memberDirectory/${storeGetters.selectedSubFilter}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
                excludedPrivateNetworksList: `memberDirectory/${storeGetters.excludedPrivateNetworksList}`,
            }),
            hasOnlyOneTypeAheadAsOption() {
                const { filterItem } = this;
                return filterItem && filterItem.filters
                    && filterItem.filters.length === 1
                    && filterItem.filters[0].isTypeAhead;
            },
            privateNetworks() {
                const privateList = [];
                if (this.excludedPrivateNetworksList &&
                    this.selectedTypeAhead &&
                    this.selectedTypeAhead.previouslySelected
                    && this.selectedTypeAhead.previouslySelected.length) {
                    this.excludedPrivateNetworksList.forEach((exItem) => {
                        const itemInSelectedList =
                            this.selectedTypeAhead.previouslySelected.find(sItem => sItem.filterValue === exItem.filterValue);
                        if (itemInSelectedList) {
                            privateList.push(itemInSelectedList);
                        }
                    });
                }
                return privateList;
            },
            thirdListOfOptions() {
                return this.selectedSubFilter && this.thirdLayerFilters
                && this.ribbonState[this.filterItem.key].includes(this.ribbonState[this.filterItem.key]
                        .find(it => it.filterKey === this.thirdLayerFilters.filterKey
                            && it.filterValue === this.thirdLayerFilters.filterValue));
            },
            typeAheadAction() {
                return this.actions[storeAction.initiateTypeAheadSearch];
            },
            displayTypeAhead() {
                return !this.isLocation && this.selectedTypeAhead && this.selectedTypeAhead.isActive
                    && this.selectedRibbonFilter && this.selectedRibbonFilter.key
                    && this.filterItem && this.filterItem.key
                    && this.selectedRibbonFilter.key === this.filterItem.key;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';
    @import '../../../common/styles/_responsive.scss';

    .filter-options {
        background-color: $ypo-extra-light-gray;
        @extend %ypo_checkbox;

        @include mobile-view-wrap;
        @include desktop-view-wrap;
        @include ellipse-handler;

        &__filters {
            background-color: $white;
            padding: 20px 40px;
        }

        &__typeAhead {
            margin-top: 20px;

            &-input {
                background-color: $white;
            }

            &-result {
                background-color: $white;
                border: 1px solid $ypo-tile-border;
                padding: 10px;
                border-top: none;
                width: 98%;
                margin-left: 1%;
                min-height: 60px !important;
                position: relative;
                max-height: 220px !important;
                overflow: auto;
                box-shadow: 0 2px 4px 0 rgba($black,0.5);

                &--item {
                    max-height: 40px !important;
                }
            }

            &-previous {
                background-color: $white;
                border: 1px solid $ypo-tile-border;
                padding-left: 10px;
            }
        }

        &__subFilters {
            
            &-options {
                background-color: $white;
                padding: 20px 40px;
            }
        }

        &__sub-label {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.23px;
            line-height: 24px;
        }

        .private_networks {
            font-size: 16px;
            letter-spacing: -0.01px;
            line-height: 22px;
        }

        .blocked-filter {
            position: absolute;
            height: 100%;
            width: 100%;
            z-index: 2;
            left: -1px;
            background-color: transparent;
        }

        .checked-box {
            &:after {
                display: block;
                left: 5px;
                top: 1px;
                width: 5px;
                height: 12px;
                border: solid #44779f;
                border-width: 0 3px 3px 0;
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg)
            }
        }
         @include breakpoint(xs) {
             background: $white;
             &__filters {
                 padding: 20px;
                 background-color: $ypo-extra-light-gray;
             }
             &__subFilters {
                &-options {
                   padding: 20px !important;
                }
            }
         }
    }

</style>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';

    .filter-options__typeAhead {

        &-input {
            .v-input__slot {
                border: 2px solid $ypo-tile-border !important;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                min-height: 35px !important;
            }

        }

        .v-text-field--box input, .v-text-field--outline input {
            margin-top: 0 !important;
            padding-top: 20px !important;
            padding-bottom: 20px !important;
        }

        &-result {
            .v-input--selection-controls.v-input .v-label {
                &:hover {
                    font-weight: 600 !important;
                }
            }
        }

    }

</style>
